import { render, staticRenderFns } from "./RemovePlan.vue?vue&type=template&id=97d66170&scoped=true"
import script from "./RemovePlan.vue?vue&type=script&lang=js"
export * from "./RemovePlan.vue?vue&type=script&lang=js"
import style0 from "./RemovePlan.vue?vue&type=style&index=0&id=97d66170&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97d66170",
  null
  
)

export default component.exports